import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetFinanceAgreementsByFundraisingId } from '@/query/queries/loan/useGetFinanceAgreementsByFundraisingId';
import config from '@/config';
import Dropdown from '@/components/Dropdown';
import { DownloadButton } from '@/components/DownloadButton';
import s from './index.module.scss';

export const FinanceAgreements = ({ fundraisingID, info, group }) => {
  const { t } = useTranslation('loans');
  const { data: agreements } = useGetFinanceAgreementsByFundraisingId(
    fundraisingID,
    group,
  );

  return (
    <div className={classnames(s.contracts, info.insurance_strategy)}>
      <Dropdown
        className={s.dropdown}
        label={
          <div className={s.header}>
            <h2 className="f-article-accent">
              {t('loan_info.financing_agreements')}
            </h2>
          </div>
        }
      >
        {fundraisingID === 92 ? (
          <div className={classnames(s.empty_message, 'f-16')}>
            {t('loan_info.files_being_processed')}
          </div>
        ) : agreements?.length ? (
          <div className={s.table__wrapper}>
            <div className={s.table__inner}>
              <div className={s.table}>
                <div className={s.table__thead}>
                  <div className={s.table__thead_col}>
                    {t('loan_info.loan_type')}
                  </div>
                  <div className={s.table__thead_col}>
                    {t('loan_info.loan_number')}
                  </div>
                  <div className={s.table__thead_col}>
                    {t('loan_info.download_agreements')}
                  </div>
                </div>
                <div className={s.table__tbody}>
                  {agreements.map(agreement => (
                    <div className={s.table__tbody_row} key={agreement.id}>
                      <div className={s.table__tbody_col}>
                        <span className="f-small-regular">
                          {agreement.risk_group_title}
                        </span>
                      </div>
                      <div className={s.table__tbody_col}>
                        <span className="f-small-regular">
                          {`${t('loan_info.loan')} #${agreement.id}`}
                        </span>
                      </div>
                      <div className={s.table__tbody_col}>
                        <DownloadButton
                          filename={`loan-assignments-${agreement.id}`}
                          link={`${config.apiURL}/loans/${agreement.id}/assignments/`}
                        >
                          <span className="f-small-regular">{t('loan_info.download')}</span>
                        </DownloadButton>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={classnames(s.empty_message, 'f-small-regular')}>
            {t('loan_info.no_agreements_yet')}
          </div>
        )}
      </Dropdown>
    </div>
  );
};
